import type { RevisionPageDocument } from '@gitbook/hive-core';
import { useHiveComputedOrigin } from '@gitbook/hive-react';

import { PageSkeleton } from '../Skeleton';
import { PageComputedHeaderAlert, PageImportHeaderAlert } from './PageHeader';

/**
 * Skeleton for a page where we are loading the content (document or computed content)
 */
export function PageContentSkeleton(props: { page: RevisionPageDocument }) {
    const { page } = props;
    const computedOrigin = useHiveComputedOrigin({
        objectType: 'pages',
        objectId: page.id,
    });

    return (
        <PageSkeleton
            header={
                computedOrigin ? (
                    <PageComputedHeaderAlert computedOrigin={computedOrigin} isComputing />
                ) : (
                    <PageImportHeaderAlert pageId={page.id} />
                )
            }
            cover={page.cover}
        />
    );
}
